<section class="programming-legend" [class.expanded]="isExpanded">
  <div class="legend-summary">
    <div class="summary-left">
      <span class="summary-icon">
        <mat-icon>tips_and_updates</mat-icon>
      </span>
      <div>
        <span class="summary-eyebrow">Guía rápida</span>
        <h3>Leyenda de la tabla</h3>
        <p>Iconos, colores y señales para interpretar los files de programación.</p>
      </div>
    </div>

    <div class="summary-right">
      <button
        type="button"
        mat-stroked-button
        class="states-flow-button"
        matTooltip="Ver explicación completa de estados y transiciones"
        (click)="openFileStates.emit()"
      >
        <mat-icon>account_tree</mat-icon>
        Estados de file
      </button>
      <button type="button" mat-button class="legend-toggle-button" (click)="toggleExpanded()">
        <span>{{ isExpanded ? 'Ocultar leyenda' : 'Ver leyenda' }}</span>
        <mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    </div>
  </div>

  <div class="legend-content" *ngIf="isExpanded">
    <article class="legend-section" *ngFor="let section of sections">
      <div class="section-heading">
        <h4>{{ section.title }}</h4>
        <p>{{ section.description }}</p>
      </div>

      <div class="legend-items">
        <div class="legend-item" *ngFor="let item of section.items" [class]="'tone-' + item.tone">
          <span class="legend-item-icon">
            <i-tabler *ngIf="item.iconType === 'tabler'; else materialLegendIcon" [name]="item.icon"></i-tabler>
            <ng-template #materialLegendIcon>
              <mat-icon>{{ item.icon }}</mat-icon>
            </ng-template>
          </span>
          <div>
            <strong>{{ item.title }}</strong>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </article>
  </div>
</section>
